

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const formatBRL = (v) =>
  Number(v || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });

export const blankForm = () => ({
  payer_person_type: "PJ",
  payer_name: "",
  payer_document: "",
  payer_address: "",
  payer_email: "",
  amount: "",
  reason: "",
  associate_id: "",
  boleto_number: "",
});

export const Label = ({ children }) => (
  <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
    {children}
  </label>
);

export const Input = ({ testid, ...rest }) => (
  <input
    data-testid={testid}
    {...rest}
    className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm focus:outline-none focus:ring-2 focus:ring-[#002776]/30 focus:border-[#002776]"
  />
);
